import React from 'react'
import Header from '../../Components/Header'
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar'
import BranchMaster from './BranchMaster'
import RegionMaster from './RegionMaster'
import ZonalMaster from './ZonalMaster'
import NationalHead from './NationalHead'
import BusinessHead from './BusinessHead'

export default function Hierarchy(props) {
  return (
    <div>
      <Header title={props.title} portal={"RM"}/>
      <SingleSignOnSideBar />
      <main id="main-content" className='heirarchy-base'>
                <div className="tab-content card-box" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="branch-tab"
                                            data-toggle="tab"
                                            data-target="#branch"
                                            type="button"
                                            role="tab"
                                            aria-controls="branch"
                                            aria-selected="true"
                                        >
                                           Branch Master
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className="nav-link"
                                            id="region-tab"
                                            data-toggle="tab"
                                            data-target="#region"
                                            type="button"
                                            role="tab"
                                            aria-controls="region"
                                            aria-selected="false"
                                        >
                                            Region Master
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="zonal-tab"
                                            data-toggle="tab"
                                            data-target="#zonalmaster"
                                            type="button"
                                            role="tab"
                                            aria-controls="zonalmaster-tab"
                                            aria-selected="false"
                                        >
                                            Zonal Master
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="nationalhead-tab"
                                            data-toggle="tab"
                                            data-target="#nationalhead"
                                            type="button"
                                            role="tab"
                                            aria-controls="natioalhead-tab"
                                            aria-selected="false"
                                        >
                                            National Head
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="businesshead-tab"
                                            data-toggle="tab"
                                            data-target="#businesshead"
                                            type="button"
                                            role="tab"
                                            aria-controls="businesshead-tab"
                                            aria-selected="false"
                                        >
                                            Business Head
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                    <div
                                        className="tab-pane fade show active"
                                        id="branch"
                                        role="tabpanel"
                                        aria-labelledby="nav-branch-tab"
                                    >
                                        <BranchMaster/>
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="region"
                                        role="tabpanel"
                                        aria-labelledby="nav-region-tab"
                                    >
                                        <RegionMaster />
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="zonalmaster"
                                        role="tabpanel"
                                        aria-labelledby="nav-zonalmaster-tab"
                                    >
                                        <ZonalMaster />
                                    </div>
                                     <div
                                        className="tab-pane fade show "
                                        id="nationalhead"
                                        role="tabpanel"
                                        aria-labelledby="nav-nationalhead-tab"
                                    >
                                        <NationalHead />
                                    </div>
                                     <div
                                        className="tab-pane fade show "
                                        id="businesshead"
                                        role="tabpanel"
                                        aria-labelledby="nav-businesshead-tab"
                                    >
                                        <BusinessHead/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
    </div>
  )
}
